// frontend/src/app/components/projects/project-corpus/job-context-bar.component.ts
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, computed, signal } from '@angular/core';
import { ImportJob, ImportSourceType } from '../../../project-corpus/domain/types';

const SOURCE_LABELS: Record<ImportSourceType, string> = {
  OPENALEX: 'OpenAlex',
  BIBTEX: 'BibTeX',
  PDF: 'PDF upload',
  GROUP_CORPUS: 'Group corpus',
};

/**
 * Thin banner above the paper list that surfaces the currently-active job
 * filter and offers a quick clear-× button. Renders nothing when `job` is
 * null.
 */
@Component({
  selector: 'app-job-context-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './job-context-bar.component.html',
  styleUrls: ['./job-context-bar.component.scss'],
})
export class JobContextBarComponent {
  private readonly _job = signal<ImportJob | null>(null);

  @Input()
  set job(value: ImportJob | null) {
    this._job.set(value);
  }
  get job(): ImportJob | null {
    return this._job();
  }

  @Output() clear = new EventEmitter<void>();

  readonly currentJob = this._job.asReadonly();

  readonly label = computed(() => {
    const j = this._job();
    if (!j) return '';
    const src = SOURCE_LABELS[j.source];
    return j.descriptor ? `${src}: ${j.descriptor}` : src;
  });

  onClear(): void {
    this.clear.emit();
  }
}
